<template>
  <!-- 签到 -->
  <div class="sign ">
    <div class="siandiv">
      <div class="signline"></div>
      <div class="signicon"></div>
      <div class="signtxt"></div>
      <div class="signbtn">
        <button>我要签到</button>
      </div>
    </div>
    <div class="maskbg"></div>
  </div>
</template>

/* eslint-enable */
<script>
/* eslint-enable */
export default {
  methods: {},
  created() {},
  mounted() {
    // 签到
    const _this = this;
    // eslint-disable-next-line no-undef
    DWLive.onStartRollCall = function (data) {
      if (window.ROLLCALL_INTERVAL_TIMER > 0) {
        clearInterval(window.ROLLCALL_INTERVAL_TIMER);
        window.ROLLCALL_INTERVAL_TIMER = -1;
      }

      const rid = data.rollcallId;
      const pid = data.publisherId;
      let time = data.duration;
      $('.signtxt')
        .html('签到倒计时: <span id="signtime">00:00</span>')
        .css('margin-top', '75px');
      $('.signbtn button').show();
      $('#signtime').text(timeFormat(time));
      $('.sign').show();
      $('.signbtn button').click(() => {
        $('.signtxt')
          .html('签到成功')
          .css('margin-top', '70px');
        DWLive.answerRollcall(rid, pid);
        setTimeout(() => {
          $('.sign').hide();
        }, 1000);

        if (window.ROLLCALL_INTERVAL_TIMER > 0) {
          clearInterval(window.ROLLCALL_INTERVAL_TIMER);
          window.ROLLCALL_INTERVAL_TIMER = -1;
        }
      });

      window.ROLLCALL_INTERVAL_TIMER = setInterval(() => {
        if (time > 1) {
          time--;
          $('#signtime').text(timeFormat(time));
        } else {
          $('.signtxt')
            .html('签到结束')
            .css('margin-top', '70px');
          $('.signbtn button').hide();
          $('.sign').hide();
          setTimeout(() => {
            // $('.sign').hide();
          }, 2000);
          if (window.ROLLCALL_INTERVAL_TIMER > 0) {
            clearInterval(window.ROLLCALL_INTERVAL_TIMER);
            window.ROLLCALL_INTERVAL_TIMER = -1;
          }
        }
      }, 1000);
    };

    function timeFormat(time) {
      const t = parseInt(time);
      let h;
      let i;
      let s;
      h = Math.floor(t / 3600);
      h = h ? `${h}:` : '';
      i = h ? Math.floor((t % 3600) / 60) : Math.floor(t / 60);
      s = Math.floor(t % 60);
      i = i > 9 ? i : `0${i}`;
      s = s > 9 ? s : `0${s}`;
      return `${h + i}:${s}`;
    }
  },
};
</script>
